export default __webpack_public_path__ + "static/media/sanmat10.4610c3f0.jpg";